import {SanitySettings} from '../../../types';
import PortableText from '../../portableText/PortableText.client';

export default function PdfPattern(settings: SanitySettings) {
  return (
    <div className="mt-8 text-sm">
      <PortableText blocks={settings.pdfPattern} />
    </div>
  );
}
